import { GetAppConfig } from './api';

/* 预加载 wujie 组件 - 使用动态 import() 实现真正的异步按需加载 */
const { VUE_APP_WITH_CUSTOM: appWithCustom } = process.env;

// 动态 import wujie-vue2，webpack 会将其拆分为独立异步 chunk
// 只有调用 preloadWujieCustom 时才会下载 wujie-vue2 的代码
let _wujieVuePromise = null;
function getWujieVue() {
  if (!_wujieVuePromise) {
    _wujieVuePromise = import(/* webpackChunkName: "chunk-wujie-vue2" */ 'wujie-vue2')
      .then(m => m.default || m);
  }
  return _wujieVuePromise;
}

export async function getPageConfig(key, type) {
  try {
    const appConfig = await GetAppConfig();
    const valueStr = appConfig?.page_config?.[key];
    if (type !== 'array' && type !== 'object') {
      return valueStr;
    }
    return JSON.parse(valueStr);
  } catch (e) {
    return type === 'array' ? [] : type === 'object' ? {} : undefined;
  }
}

export async function preloadWujieCustom(tenant) {
  if (!tenant) {
    return;
  }

  const WujieVue = await getWujieVue();
  const { preloadApp } = WujieVue;

  // 默认页面不能被 403, /custom/ 会被 403
  // 预加载要加载对应租户下的 index.html
  const wujiePreload = `${appWithCustom ? 'http://localhost:9090' : ''}/custom/${tenant}/`;
  console.log('wujie custom preloading', wujiePreload);

  preloadApp({
    name: 'wujie',
    url: wujiePreload,
    exec: true,
    alive: true,
    // 进入页面
    activated(appWindow) {
      console.log(`${appWindow.__WUJIE.id} custom preload activated`);
    },
    // 离开页面
    deactivated(appWindow) {
      console.log(`${appWindow.__WUJIE.id} custom preload deactivated`);
    },
    // fetch: function(url, options) {
    //   return window.fetch(url, { ...options, credentials: 'include' });
    // },
    plugins: [
      {
        htmlLoader: (code) => {
          console.log('wujie custom preload html-loader');
          return code;
        },
        // js 忽略列表 - 用于处理 JSONP 等跨域脚本
        jsIgnores: [/map\.qq\.com/, /[?&]callback=/, /[?&]output=jsonp/],
        // jsLoader: (code, url) => {
        //   console.log("wujie preload js-loader", url);
        //   return code;
        // },
        // cssLoader: (code, url) => {
        //   console.log("wujie css-loader", url, code.slice(0, 50));
        //   return code;
        // },
      },
    ],
  });
}
